module.exports = __webpack_public_path__ + "static/media/lp_skill.10fa58bd.svg";